module.exports = __webpack_public_path__ + "img/sop0-1.e97b6e12.jpg";